/* The product page's "notify me" card (catalog/templates/catalog/product-detail.html,
   `#back-in-stock-card`).

   Both ways in post in the background — a signed-in customer's one-click form,
   and a visitor's modal (`#back-in-stock-dialog`: opens on
   `[data-open-dialog="back-in-stock-dialog"]`, closes on its × or a click on the
   backdrop; Esc is the native `<dialog>`'s). While the request is out the
   button spins; `catalog.views.notify_back_in_stock` answers with the
   "¡Listo!" card, which replaces this one in place — no reload. A refusal is
   shown beside the button. The server validates the address — there is no
   second check here. Only a request that never reached the server falls back
   to a plain post. */
(function () {
    var card = document.getElementById('back-in-stock-card');
    if (!card) return;
    var dialog = document.getElementById('back-in-stock-dialog');

    if (dialog && typeof dialog.showModal === 'function') {
        var dialogInput = dialog.querySelector('input[name="email"]');
        document.querySelectorAll('[data-open-dialog="back-in-stock-dialog"]').forEach(function (button) {
            button.addEventListener('click', function () {
                dialog.showModal();
                dialogInput.focus();
            });
        });
        dialog.querySelector('[data-close-dialog]').addEventListener('click', function () {
            dialog.close();
        });
        // A click on the backdrop lands on the dialog element itself.
        dialog.addEventListener('click', function (event) {
            if (event.target === dialog) dialog.close();
        });
    }

    var showDone = function (html) {
        if (dialog && dialog.open) dialog.close();
        var holder = document.createElement('div');
        holder.innerHTML = html.trim();
        card.replaceWith(holder.firstElementChild);
        if (dialog) dialog.remove();
    };

    document.querySelectorAll('[data-back-in-stock-form]').forEach(function (form) {
        var input = form.querySelector('input[name="email"]');
        var error = form.querySelector('[data-error]');
        var submit = form.querySelector('button[type="submit"]');
        var busy = false;

        // Not `disabled`: the theme greys a disabled button out, which reads as
        // "refused" rather than "working on it".
        var setBusy = function (on) {
            busy = on;
            submit.classList.toggle('is-loading', on);
            submit.setAttribute('aria-busy', on ? 'true' : 'false');
        };
        var showError = function (message) {
            setBusy(false);
            error.textContent = message;
            error.hidden = false;
            if (input) {
                input.setAttribute('aria-invalid', 'true');
                input.focus();
            }
        };

        form.addEventListener('submit', function (event) {
            event.preventDefault();
            if (busy) return;
            error.hidden = true;
            if (input) input.removeAttribute('aria-invalid');
            setBusy(true);
            fetch(form.action, {
                method: 'POST',
                body: new FormData(form),
                headers: { 'X-Requested-With': 'XMLHttpRequest' },
                credentials: 'same-origin'
            }).then(function (response) {
                // A refusal the view did not word (a stale CSRF token, a product
                // just disabled, a 500) is not JSON: say so here rather than
                // re-posting into the same error page.
                return response.json().catch(function () {
                    return { ok: false, error: form.dataset.genericError };
                });
            }, function () {
                // Network trouble: fall back to a plain post.
                form.submit();
                return null;
            }).then(function (data) {
                if (!data) return;
                if (data.ok) {
                    showDone(data.html);
                    return;
                }
                showError(data.error);
            });
        });
    });
})();
